import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeUserType } from '../../redux/auth/userSlice';
import { useTranslation } from 'react-i18next';
import profileIcon from '../../assets/profileimage.jpg';
import {
    PROFILE_REMINDER_STORAGE_KEY,
    isProfileComplete
} from '../../utils/profileCompletion';

import '../../styles/UserDropdown.scss';

const UserDropdown = ({ logoutClick, onSellerProfileReminder }) => {
    const [userType, setUserType] = useState('buyer');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const _user = useSelector((state) => state.user);
    const _userProfileData = useSelector((state) => state.profile.userProfile);
    const profileName =
        _userProfileData?.firstname && _userProfileData?.lastname
            ? `${_userProfileData.firstname} ${_userProfileData.lastname}`
            : _user.displayName || t('dropdown.users-name');
    const profileImage =
        (_user?.photoURL?.startsWith('http') && _user.photoURL) ||
        (_userProfileData?.url?.startsWith('http') && _userProfileData.url) ||
        profileIcon;

    const sellerLinks = [
        { path: '/seller/dashboard', text: 'Dashboard' },
        { path: '/calendar', text: 'Calendar' },
        { path: '/seller/own-jobs', text: 'Create a job' }
    ];

    const buyerLinks = [
        { path: '/buyer/orders', text: 'Dashboard' },
        { path: '/search', text: 'Search' }
    ];

    const links = userType === 'seller' ? sellerLinks : buyerLinks;

    useEffect(() => {
        if (['buyer', 'seller'].includes(_user.userType)) {
        setUserType(_user.userType);
        }
    }, [_user.userType]);

    function switchUserType(type) {
        if (_user.userType !== type) {
        dispatch(changeUserType({ uid: _user.uid, userType: type }));
        if (
            type === 'seller' &&
            !isProfileComplete(_userProfileData, 'seller') &&
            localStorage.getItem(PROFILE_REMINDER_STORAGE_KEY) !== 'true'
        ) {
            onSellerProfileReminder?.();
        }
        if (_user.userType === 'buyer') {
            navigate('/seller/dashboard');
        } else if (_user.userType === 'seller') {
            navigate('/buyer/orders');
        }
        }
    }

  return (
    <div className="mobile-user-dropdown-container">
        <div className="mobile-user-dropdown-profile">
            <img
                className="mobile-user-dropdown-avatar"
                src={profileImage}
                onError={(event) => {
                    event.currentTarget.onerror = null;
                    event.currentTarget.src = profileIcon;
                }}
                referrerPolicy="no-referrer"
                alt="User Avatar"
            />
            <p>{profileName}</p>
        </div>

        <div className="dropdown-button-container">
            {links.map((link) => (
                <Link to={link.path} className="dropdown-button-content" key={link.path}>
                    <button className="dropdown-button">{t(`dropdown.${link.text}`)}</button>
                </Link>
            ))}
        </div>

        <div className="switch-user-content">
            <div className="switch-user-label">
            <p>{t('dropdown.Switch User')}</p>
            </div>
            <div className="switch-user-buttons">
                <button
                    className={`switch-button ${userType === 'buyer' ? 'selected' : ''}`}
                    onClick={() => switchUserType('buyer')}>
                    {t('dropdown.Buyer')}
                </button>
                <button
                    className={`switch-button ${userType === 'seller' ? 'selected' : ''}`}
                    onClick={() => switchUserType('seller')}>
                    {t('dropdown.Seller')}
                </button>
            </div>
        </div>

        <div className="logout-button-content">
            <button className="logout-button" onClick={logoutClick}>
            {t('dropdown.Log out')}
            </button>
        </div>
    </div>
  );
};

export default UserDropdown;
